import React, { Component } from "react";
import { TableDefault, LabelString, LabelDollarFormatted, LabelDate } from "@loanbossinc/component-library";
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';


const LOAN_LOCKOUT = "LOCKOUT";
const DEFAULT_LENDER_NAME = "Lender Selection Needed";

export class ActiveLoanBodyList extends Component {
    loanTableCols = () => {
        return [
            {
                id: 'loan'
                , label: 'LENDER'
                , path: 'loan'
                , Cell: (value) => value.lienPriority ? (
                    <Tooltip title={value.lienPriority} TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right-start">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <LabelString style={{ color: "#000", fontWeight: "500" }} value={value.loanSeniority} />
                            {value.lenderCompanyName && <LabelString value={value.lenderCompanyName} />}
                        </div>
                    </Tooltip>
                ) :
                (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <LabelString style={{ color: "#000", fontWeight: "500" }} value={value.loanSeniority} />
                        {value.lenderCompanyName && <LabelString value={value.lenderCompanyName} />}
                    </div>
                )
            }
            , {
                id: 'currentPrincipalBalance'
                , label: 'CURRENT BALANCE'
                , path: 'currentPrincipalBalance'
                , Cell: (value) => <LabelDollarFormatted value={value} decimals={0} />
            }
            , {
                id: 'maturityDate'
                , label: 'MATURITY'
                , path: 'maturityDate'
                , Cell: (value) => ( <LabelDate value={value} />)
            }
            , {
                id: 'prepaymentPenalty'
                , label: 'PREPAYMENT'
                , path: 'prepaymentPenalty'
                , Cell: (value) => (
                    value === LOAN_LOCKOUT ? <LabelString value={value} /> : <LabelDollarFormatted value={value} decimals={0} />
                )
            }
        ]
    }

    getLenderCompanyName = (loan) => {
        if (!loan || !loan.lenderCompany || !loan.lenderCompany.name) return DEFAULT_LENDER_NAME;
        const lenderCompanyName = loan.lenderCompany.name;
        return lenderCompanyName.length > 20 ? `${loan.lenderCompany.name.slice(0, 20)} ... ` : lenderCompanyName;
    }

    getLoanSeniority = (loan) => {
        if (!loan || !loan.loanSeniority || !loan.loanSeniority.value) return null;
        const closingDate = !loan.closingDate ? "" : `- ${moment(loan.closingDate).format('YYYY')}`;
        return `${loan.loanSeniority.value} ${closingDate}`.trim();
    }
    getLienPriority = (loan) => {
        if (!loan || !loan.lienPriority ) return null;        
        return `Lien Priority: ${loan.lienPriority}`.trim();
    }
    getColumnData = () => {
        const { loans } = this.props;
        return loans.reduce((acc, cur) => {
            acc.push({
                id: cur.id
                , prepaymentPenalty: cur.isLockout ? LOAN_LOCKOUT : cur.prepaymentPenalty
                , maturityDate: cur.maturityDate
                , currentPrincipalBalance: cur.currentPrincipalBalance
                , loan: {
                    loanSeniority: this.getLoanSeniority(cur)
                    , lenderCompanyName: this.getLenderCompanyName(cur)
                    ,lienPriority: this.getLienPriority(cur)
                }
            })
            return acc;
        }, []);
    }

    render() {
        const { dealId, toLoanDetails } = this.props;
        return (
            <div>
                <TableDefault
                    elevation={0}
                    columns={this.loanTableCols()}
                    items={this.getColumnData()}
                    onRowClick={(loan) => { toLoanDetails(dealId, loan.id) }} />
            </div>
        )
    }
}